export default "__VITE_ASSET__ChL8O2Jf__"